import { useAuthStore } from 'features/auth/stores/authStore';
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ROUTE_PATHS } from 'shared/constants/routes';

export const ProtectedRoute: React.FC = () => {
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={ROUTE_PATHS.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
};
